document.querySelectorAll('.block-school-listing').forEach(($block) => {
    const $listItems = Array.from($block.querySelectorAll('ul li'));
    const $button = $block.querySelector('.btn-showall');

    const {
        dataset: { collapsedText, expandedText },
    } = $button;

    const $label = $button.querySelector('.btn-showall-label');
    const $iconExpand = $button.querySelector('.icon-expand');
    const $iconCollapse = $button.querySelector('.icon-collapse');

    if ($listItems.length <= 6) {
        $button.style.display = 'none';
        return;
    }

    const showItems = (expanded) => {
        $listItems.forEach((item, index) => {
            const $item = item;
            $item.style.display = expanded || index < 6 ? '' : 'none';
        });

        $label.textContent = expanded ? expandedText : collapsedText;
        $iconExpand.style.display = expanded ? 'none' : '';
        $iconCollapse.style.display = expanded ? '' : 'none';
        $button.setAttribute('aria-expanded', expanded);
    };

    showItems(false);

    $button.addEventListener('click', () => {
        const isExpanded = $button.getAttribute('aria-expanded') === 'true';
        showItems(!isExpanded);
    });
});
